import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Switch } from 'antd';
// import { useNavigate } from "react-router-dom";
import { FormBox, InputBox } from '../../../components/AntdAddons';
import { LoginRequest } from './Validation';
import { useDispatch, useSelector } from 'react-redux';
import { doRegister } from '../../../store/AuthSlice';
import { AppDispatch, RootState } from '../../../store/app';
import { Link, useNavigate } from 'react-router-dom';
// import { stringDecryption } from '../../../config/Global';
import { assignErrorToInput } from '../../../store/api';
import Logo from '../../../assets/images/logo.svg';
import { CONSTANT } from '../../../config/Constant';
import { validations } from '../../../config/validations/validations';

const RegisterForm: React.FC<any> = (props) => {
  const { isAdd, isEdit, dataEditModal, editSubmit, handleAddModa, getList } = props;
  const dispatch: AppDispatch = useDispatch();
  const Auth = useSelector((state: RootState) => state.AUTH);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [activeUser, setActiveUser] = useState<boolean>(dataEditModal?.active);

  const handleBlockUser = (val: boolean) => {
    setActiveUser(val);
  };

  const handleSubmit = (data: any) => {
    if (isEdit) {
      const payload = {
        ...data,
        active: activeUser,
      };
      editSubmit(payload);
    } else {
      dispatch(doRegister(data))
        .then(() => {
          if (isAdd) {
            navigate('/users');
          } else if (isEdit) {
            navigate('/users');
          } else {
            navigate('/');
          }
          handleAddModa();
          getList();
        })
        .catch((error: any) => {
          assignErrorToInput(form, error?.notification);
        });
    }
  };

  useEffect(() => {
    if (dataEditModal) {
      form.setFieldsValue({
        ...dataEditModal,
        // roles: dataEditModal?.roles,
      });
      // setRememberMe(true);
    }
  }, [form, dataEditModal]);

  return (
    <div className="loginForm">
      <div className="loginFormWrap">
        {!isAdd ? (
          <>
            <img
              src={Logo}
              alt="logo"
              className="logo"
            />
            <div className="formTitle">
              <h2 className="title">Register Now </h2>
            </div>
          </>
        ) : null}
        <FormBox
          form={form}
          onFinish={handleSubmit}
          autoComplete="off"
          className={isAdd ? 'filterForm' : ''}
        >
          <Row gutter={20}>
            <Col xs={24}>
              <InputBox.Text
                name="full_name"
                label={'Full Name'}
                placeholder="Full name"
                required
                rules={[
                  // LoginRequest().user('Fullname'),
                  validations.required.text('Full Name'),
                  validations.pattern.whitespace,
                ]}
              />
            </Col>
            <Col
              xs={24}
              lg={isEdit ? 12 : 24}
            >
              <InputBox.Text
                name="username"
                label={'Username'}
                placeholder="Username"
                autoComplete="off"
                required
                rules={[validations.required.text('Username'), validations.pattern.whitespace]}
                disabled={isEdit}
              />
            </Col>
            <Col
              xs={24}
              lg={isEdit ? 12 : 24}
            >
              <InputBox.Text
                name="email"
                label={'Email'}
                placeholder="Email"
                required
                rules={[
                  validations.required.text('Email'),
                  validations.pattern.email(),
                  validations.pattern.whitespace,
                ]}
                disabled={isEdit}
              />
            </Col>
            {!isEdit ? (
              <>
                <Col
                  xs={24}
                  lg={12}
                >
                  <InputBox.Password
                    name="password"
                    label="Password"
                    placeholder="xxxxxxx"
                    rules={[
                      validations.required.text('Password'),
                      validations.pattern.password(),
                      validations.pattern.whitespace,
                    ]}
                  />
                </Col>
                <Col
                  xs={24}
                  lg={12}
                >
                  <InputBox.Password
                    name="confirm_password"
                    label="Confirm Password"
                    placeholder="xxxxxxx"
                    rules={LoginRequest().confirmPassword('Confirm Password')}
                  />
                </Col>
              </>
            ) : (
              <>
                <Col
                  xs={24}
                  lg={5}
                >
                  <Form.Item label="Status">
                    <Switch
                      value={activeUser}
                      onChange={(e: boolean) => {
                        handleBlockUser(e);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  lg={12}
                >
                  <InputBox.Select
                    label="Role"
                    name={'roles'}
                    allowClear
                    showSearch
                    mode="multiple"
                    placeholder="Please select roles"
                    // defaultValue={dataEditModal?.roles}
                    options={{
                      list: CONSTANT.PERMISSION_ARRAY,
                      valueKey: 'id',
                      textKey: 'value',
                    }}
                  />
                </Col>
                <Col
                  xs={24}
                  lg={7}
                >
                  <InputBox.Select
                    label="Language"
                    name={'language'}
                    allowClear
                    showSearch
                    initialValue={'english'}
                    options={{
                      list: CONSTANT.LANGUAGES,
                      valueKey: 'id',
                      textKey: 'value',
                    }}
                  />
                </Col>
              </>
            )}
            <Col xs={24}>
              <div
                className="text-center"
                style={{ width: '100%' }}
              >
                <Button
                  loading={isAdd ? false : !isEdit ? false : Auth.isLoading}
                  type="primary"
                  htmlType="submit"
                  style={{ width: '100%' }}
                >
                  {isEdit ? 'Edit User' : isAdd ? 'Add User' : 'Register'}
                </Button>
              </div>
              {!isAdd ? (
                <div className="mt-10 font-medium login_extra_fields text-right">
                  Already have Account? <Link to="/login">Log In.</Link>
                </div>
              ) : null}
            </Col>
          </Row>
        </FormBox>
      </div>
    </div>
  );
};

export default RegisterForm;
